angular
    .module('app')
    .component('schoolsEdit', {
        templateUrl: '/templates/pages/schools/schoolsEdit/schoolsEdit.html',
        controller: 'SchoolEditController',
        controllerAs: 'vm',
    });